module.exports = __webpack_public_path__ + "static/media/search.f4bfa340.svg";